// extracted by mini-css-extract-plugin
module.exports = {"bgimg":"AddPicture_bgimg__UOUS9","content":"AddPicture_content__lKmJ4","field":"AddPicture_field__18BsM","Add":"AddPicture_Add__1zPEH"};